import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { GlobalContext } from "../../utility/GlobalContext";
import socialService from "../../services/socialService";
import ListReviews from "../../components/common/ListReviews";
import reviewService from "../../services/reviewService";
import userService from "../../services/userService";
import { Modal, Button, Col, Row, Container } from "react-bootstrap";
import ReviewCreatorForm from "../../components/Creator/ReviewCreatorForm";
import tiktokIcon from "../../assets/images/tiktok-icon.png";
import instagramIcon from "../../assets/images/instagram-icon.png";

export default function SocialPage(props) {
  const history = useHistory();
  const { state, setState } = useContext(GlobalContext);
  const handle = useParams().handle.replace("@", "");
  const platform = window.location.pathname.split("/")[1];
  const [social, setSocial] = useState({});
  const [reviews, setReviews] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchUser();
  }, [state.jwt]);

  useEffect(() => {
    fetchSocial();
  }, [platform, handle]);

  const fetchSocial = () => {
    socialService
      .fetch(handle, platform)
      .then((response) => {
        setSocial(response.data);
        fetchReviews(response.data.id);
      })
      .catch((err) => {
        toast.error((err.response && err.response.data.msg) || "Error occurred");
      });
  };

  const fetchUser = () => {
    if (!state.jwt) {
      return;
    }
    userService
      .fetchSelf(state.jwt)
      .then((response) => {
        console.log("FETCH USER: ", response.data);
        setState({ ...state, user: response.data });
      })
      .catch((err) => {
        // toast.error(err.response.data.msg || "Error occurred")
      });
  };

  const fetchReviews = (id) => {
    reviewService
      .list(id, "social")
      .then((response) => {
        console.log("Reviews: ", response.data);
        setReviews(response.data);
      })
      .catch((err) => {});
  };

  const getSocialURL = () => {
    if (social.platform === "instagram") {
      return `https://instagram.com/${social.handle}`;
    }
    if (social.platform === "tiktok") {
      return `https://tiktok.com/@${social.handle}`;
    }
  };

  const reset = () => {
    fetchSocial();
    setShowModal(false);
  };

  const canClaim = () => {
    return !state.user || (state.user && state.user.type === "creator");
  };

  const claimText = () => {
    if (social.status === "claimed") {
      return "Claimed by verified user ✅";
    }
    if (social.status === "pending") {
      return "Pending verification ⏳";
    }

    if (social.status === "unclaimed") {
      return "Unclaimed -- sign up and claim if you own it!";
    }
  };

  return (
    <Container>
      <Row>
        <img src={platform === "tiktok" ? tiktokIcon : instagramIcon} />
        <h2 style={{ marginTop: 5 }}>@{handle}</h2>
      </Row>
      <a target="_blank" href={getSocialURL()}>
        {social && getSocialURL()}
      </a>
      <p>{claimText()}</p>
      {/* {canClaim() && <a href="#">You own this? Claim it</a>} */}
      <hr></hr>
      {state.user &&
        state.user.type === "business" &&
        state.user.Business &&
        state.user.Business.status === "claimed" && (
          <div>
            <Button
              onClick={() =>
                social.id ? setShowModal(true) : history.push("/new_review")
              }
            >
              Write Review
            </Button>
            <Modal
              onHide={() => setShowModal(false)}
              dialogClassName="my-modal"
              show={showModal}
            >
              <ReviewCreatorForm
                jwt={state.jwt}
                currentUserID={state.currentUserID}
                social={social}
                businessID={state.user.Business.id}
                user={state.user}
                onReviewSucceeded={reset}
              />
            </Modal>
          </div>
        )}
      <div>
        <h3>Reviews:</h3>
        <ListReviews reviews={reviews} social={social} />
      </div>
    </Container>
  );
}
